<div class="container">

    <div class="arrow-bg left" [class.show-arrow]="showArrowLeft" [class.round]="roundButtons" (click)="previous()">
      <img alt="Left Arrow" src="./assets/images/white_left_arrow.png">
    </div>
  
    <div class="cm-container" #cmContainer>
        <ng-content></ng-content>
    </div>

    <div class="arrow-bg right" [class.show-arrow]="showArrowRight" [class.round]="roundButtons" (click)="next()">
      <img alt="Right Arrow" src="./assets/images/white_right_arrow.png">
    </div>
  
</div>